'use client';

import { ComponentPropsWithoutRef, type FC } from 'react';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { cn } from '@wwe-portal/ui/lib/lib';

export interface RosterTotalStatsV2Props {
  totalScore: React.ReactNode | undefined;
  totalHP: React.ReactNode | undefined;
}

interface StatProps {
  icon: React.ReactNode;
  value: React.ReactNode;
  label: React.ReactNode;
}

export const RosterTotalStatsV2: FC<
  ComponentPropsWithoutRef<'div'> & RosterTotalStatsV2Props
> = ({ totalScore, totalHP, className, ...props }) => {
  return (
    <div
      className={cn('drop-shadow-card flex w-full p-4', className)}
      style={{
        background:
          'linear-gradient(180deg, #303452 20.19%, #272B4A 60.1%, #343855 100%)',
      }}
      {...props}
    >
      <div className="flex flex-1 items-center justify-center">
        <StatItem
          icon={
            <IcoMoonIcon
              iconName="shield-cross-fill"
              className="text-blue600 h-6 w-6"
            />
          }
          value={totalScore}
          label="Total Talent"
        />
      </div>

      <div className="mx-4 h-auto w-px bg-[#2a3655]"></div>

      <div className="flex flex-1 items-center justify-center">
        <StatItem
          icon={
            <IcoMoonIcon
              iconName="shield-cross-empty"
              className="text-blue600 h-6 w-6"
            />
          }
          value={totalHP}
          label="Total HP"
        />
      </div>
    </div>
  );
};

const StatItem: FC<StatProps> = ({ icon, value, label }) => {
  return (
    <div className="flex items-center gap-2 italic">
      {icon}
      <div className="flex flex-col">
        <span className="text-blue600 text-sm font-semibold">{value}</span>
        <span className="text-sm font-semibold text-[#9ca3af]">{label}</span>
      </div>
    </div>
  );
};
